import React, { useState, useEffect } from "react";
import TopBar from "../../common/TopBar";
import Sidebar from "../../common/Sidebar";
import "./landing.css";
import { DataGrid } from "@mui/x-data-grid";
import { ToastContainer, toast } from "react-toastify";
import {
    Button,
    Box,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
} from "@mui/material";
import { FiEdit, FiTrash2, FiPlus } from "react-icons/fi";
import {
    getTopThingsToDoList,
    handleDeleteTopThingsToDoById,
    updateFullTrip,
    fetchAllTourPlaces,
    fetchCategoryDetails,
    createTourOverview,
    createTourHighlights,
    createTourPackages,
    fetchUnmappedTopThings,
    fetchMappedTopThings,
    createTourTips,
    createTourThingsToBring,
    createTourDurationTimings,
    createTourPickupLocations,
    createTourInstructions,
    createTourGallery
} from "../../../services/adminRestapiService";


import TourOverView from "./TourOverView";
import PackagesPage from "./PackagesPage";
import DynamicTextList from "./DynamicTextList";
import Itinerary from "./Itinerary";
import TourGallery from "./TourGallery";
import TermsConditions from "./TermsConditions";
import TourHighlights from "./TourHighlights";
import TipsWeSuggest from "./TipsWeSuggest";
import DurationandTimings from "./DurationandTimings";
import PickUpInFormation from "./PickUpInFormation";
import TourInstructions from "./TourInstructions";
import CancellationPolicy from "./CancellationPolicy";

function LandingPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [topThings, setTopThings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [categoryList, setCategoryList] = useState([]);
    const [titleList, setTitleList] = useState([]);
    const [mappedTours, setMappedTours] = useState([]);
    const [activeTab, setActiveTab] = useState("overview");
    // -------- NEW SECTIONS (MATCH YOUR FRONTEND) --------
    const [tips, setTips] = useState([""]);
    const [gallery, setGallery] = useState([]);


    const [durationTimings, setDurationTimings] = useState({
        timings: "",
        duration: ""
    });
    const [pickupLocations, setPickupLocations] = useState([""]);
    const [instructions, setInstructions] = useState([""]);
    const [cancellationPolicies, setCancellationPolicies] = useState([""]);
    const [tourDetails, setTourDetails] = useState([""]);
    const [terms, setTerms] = useState("");
    const [highlights, setHighlights] = useState("");
    const [tipsWeSuggest, setTipsWeSuggest] = useState("");
    const [pickupInfo, setPickupInfo] = useState("");
    const [tourInstructions, setTourInstructions] = useState("");
    const [cancellationPolicy, setCancellationPolicy] = useState("");




    const [howToUse, setHowToUse] = useState([""]);
    const [bringItems, setBringItems] = useState([
        { label: "📷 Camera", selected: false },
        { label: "🕶 Sunglasses", selected: false },
        { label: "👒 Hat", selected: false },
        { label: "🌞 Sunscreen", selected: false },
        { label: "👙 Swimwear", selected: false },
        { label: "💧 Water bottle", selected: false },
        { label: "👜 Waterproof bag", selected: false },
        { label: "🧣 Towel", selected: false },
        { label: "📱 Phone", selected: false },
        { label: "💰 Pocket money", selected: false },
    ]);


    const [tourOverview, setTourOverview] = useState({
        title: "",
        location: "",
        rating: "",
        review_count: "",
        recommendation_percent: "",
        subtitle: "",
        bullets: [""],
        read_more_text: "",
        short_text: ""
    });



    const [packages, setPackages] = useState([
        {
            package_name: "",
            lunch_type: "",
            duration_hours: "",
            original_price: "",
            offer_price: "",
            currency: "INR",
            includes_activities: false,
            activity_count: 0,
            is_active: true,
        },
    ]);

    const [itinerary, setItinerary] = useState([
        {
            start_time: "",
            end_time: "",
            title: "",
            location: "",
            description: "",
            travel_mode: "",
            duration: "",
            images: [],
            map_link: "",
            is_optional: false,
        }
    ]);



    const toggleSidebar = () => setSidebarOpen((isCurrentlyOpen) => !isCurrentlyOpen);

    useEffect(() => {
        const loadTitles = async () => {
            const token = localStorage.getItem("token");
            const res = await fetchUnmappedTopThings(token);
            setTitleList(res.data.data);
        };
        loadTitles();
    }, []);

    useEffect(() => {
        const loadMappedTours = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem("token");
                const res = await fetchMappedTopThings(token);
                setMappedTours(res.data.data || []);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        loadMappedTours();
    }, []);
    const usedThingIds = mappedTours.map(item => item.thing_id);
    const rows = mappedTours.map(row => ({
        id: row.thing_id,
        ...row,
    }));

    const [newTopThing, setNewTopThing] = useState({
        title: "",
        category: "",
        thing_id: "",
        description: "",
        image: null,
        price: "",
        cta_text: "",
        created_by: 1,
        categoryTitle: "",
    });

    const [openEditModal, setOpenEditModal] = useState(false);
    const [editTopThing, setEditTopThing] = useState({
        id: "",
        title: "",
        category: "",
        description: "",
        image: null,
        actual_price: "",
        discounted_price: "",
        cta_text: "",
        created_by: 1,
        trip_id: null,
    });
    const [editImageFile, setEditImageFile] = useState(null);

    const [openAddModal, setOpenAddModal] = useState(false);

    const cleanHTML = (html) => {
        if (!html) return "";
        return html === "<p></p>" ? "" : html;
    };

    // 🔥 ADD HERE
    const htmlToArray = (html) => {
        if (!html) return [];

        const div = document.createElement("div");
        div.innerHTML = html;

        const listItems = div.querySelectorAll("li");

        if (listItems.length > 0) {
            return Array.from(listItems).map(li => li.textContent.trim());
        }

        return div.innerText
            .split("\n")
            .map(text => text.trim())
            .filter(Boolean);
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            if (!newTopThing.thing_id) {
                toast.error("Please select a title before saving");
                setLoading(false);
                return;
            }

            const thing_id = newTopThing.thing_id;

            // 1️⃣ OVERVIEW
            await safeCall(() =>
                createTourOverview(token, {
                    thing_id,
                    title: tourOverview.title,
                    subtitle: tourOverview.subtitle,
                    location: tourOverview.location,
                    rating: Number(tourOverview.rating),
                    review_count: Number(tourOverview.review_count),
                    recommendation_percent: Number(tourOverview.recommendation_percent),
                    read_more_text: tourOverview.read_more_text,
                })
            );

            // 2️⃣ HIGHLIGHTS
            await safeCall(() =>
                createTourHighlights(token, {
                    thing_id,
                    short_text: cleanHTML(highlights),
                    read_more_text: tourOverview.read_more_text || ""
                })
            );

            // 3️⃣ GALLERY
            if (gallery.length > 0) {
                const formData = new FormData();
                formData.append("thing_id", thing_id);

                gallery.forEach((item) => {
                    if (item?.file) {
                        formData.append("images", item.file);
                    }
                });

                await safeCall(() =>
                    createTourGallery(token, formData)
                );
            }

            // 4️⃣ PACKAGES
            await safeCall(() =>
                createTourPackages(token, {
                    tour_id: thing_id,
                    packages,
                })
            );

            // 5️⃣ TIPS ⚠️ FIX (ARRAY REQUIRED)
            await safeCall(() =>
                createTourTips(token, {
                    thing_id,
                    tips: htmlToArray(tipsWeSuggest) // ✅ MUST
                })
            );

            // 6️⃣ BRING ITEMS
            await safeCall(() =>
                createTourThingsToBring(token, {
                    thing_id,
                    items: bringItems
                        .filter(i => i.selected)
                        .map(i => i.label)
                })
            );

            // 7️⃣ DURATION
            await safeCall(() =>
                createTourDurationTimings(token, {
                    thing_id,
                    timings: durationTimings.timings,
                    duration: durationTimings.duration
                })
            );

            // 8️⃣ PICKUP ⚠️ FIX (ARRAY REQUIRED)
            await safeCall(() =>
                createTourPickupLocations(token, {
                    thing_id,
                    locations: htmlToArray(pickupInfo)
                })
            );

            // 9️⃣ INSTRUCTIONS ⚠️ FIX (ARRAY REQUIRED)
            await safeCall(() =>
                createTourInstructions(token, {
                    thing_id,
                    instructions: htmlToArray(tourInstructions)
                })
            );

            console.log({
                highlights,
                tipsWeSuggest,
                pickupInfo,
                tourInstructions
            });



            toast.success("Tour created successfully");

        } catch (err) {
            console.error(err);
            toast.error(
                err?.response?.data?.message || "Failed to create tour"
            );
        } finally {
            setLoading(false);
        }
    };





    const safeCall = async (apiFn) => {
        try {
            const res = await apiFn();
            const data = res?.data || res;

            if (!data?.success) {
                throw new Error(data?.message || "API failed");
            }

            return data;
        } catch (err) {
            throw new Error(
                err?.response?.data?.message ||
                err.message ||
                "Something went wrong"
            );
        }
    };

    const loadPlaces = async () => {
        try {
            const res = await fetchAllTourPlaces();
            const data = res.data.data;

            const uniqueCategories = [...new Set(data.map(item => item.category))];
            setCategoryList(uniqueCategories);

        } catch (error) {
            toast.error("Failed to fetch display titles");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadPlaces();
    }, []);

    const handleCategoryChange = async (e) => {
        const selectedCategory = e.target.value;

        setNewTopThing(prev => ({
            ...prev,
            category: selectedCategory,
            categoryTitle: "",
        }));

        if (!selectedCategory) {
            setTitleList([]);
            return;
        }

        try {
            const token = localStorage.getItem("token");
            const res = await fetchCategoryDetails(token, selectedCategory);

            if (res?.data?.success) {
                setTitleList(res.data.response);
            } else {
                setTitleList([]);
            }

        } catch (err) {
            console.error("Category fetch error:", err);
            setTitleList([]);
        }
    };

    const columns = [
        { field: "thing_id", headerName: "ID", flex: 0.6 },
        { field: "title", headerName: "Title", flex: 2 },
        { field: "category", headerName: "Category", flex: 1.2 },
        {
            field: "overview_title",
            headerName: "Overview Title",
            flex: 2,
            renderCell: (params) => (
                <span>{params.value || "—"}</span>
            ),
        },
        {
            field: "rating",
            headerName: "Rating",
            flex: 0.8,
            renderCell: (params) => (
                <span>⭐ {params.value}</span>
            ),
        },
        {
            field: "review_count",
            headerName: "Reviews",
            flex: 0.8,
        },
        {
            field: "image",
            headerName: "Image",
            flex: 1.2,
            renderCell: (params) => {
                const baseURL = "https://api.gosehari.com";
                const imageURL = params.value
                    ? `${baseURL}${params.value}`
                    : "/placeholder.png";

                return (
                    <img
                        src={imageURL}
                        alt={params.row.title}
                        style={{
                            width: "80px",
                            height: "50px",
                            objectFit: "cover",
                            borderRadius: "6px",
                        }}
                    />
                );
            },
        },
        {
            field: "discounted_price",
            headerName: "Price (₹)",
            flex: 1,
        },
        {
            field: "mapped_on",
            headerName: "Mapped On",
            flex: 1.2,
            renderCell: (params) =>
                new Date(params.value).toLocaleDateString(),
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 1.2,
            renderCell: (params) => (
                <Box className="flex gap-2">
                    <IconButton
                        color="primary"
                        size="small"
                        onClick={() => setOpenEditModal(true)}
                    >
                        <FiEdit />
                    </IconButton>

                    <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleDeleteClick(params.row.thing_id)}
                    >
                        <FiTrash2 />
                    </IconButton>
                </Box>
            ),
        },
    ];

    const handleDeleteClick = async (id) => {
        if (!window.confirm("Are you sure you want to delete this item?")) return;

        try {
            const token = localStorage.getItem("token");
            await handleDeleteTopThingsToDoById(token, id);
            setTopThings((prev) => prev.filter((item) => item.id !== id));
            toast.success("Deleted successfully!");
        } catch (err) {
            console.error("Failed to delete top thing:", err);
            toast.error(err.response?.data?.message || "Failed to delete top thing");
        }
    };


    return (
        <div className="flex min-h-screen bg-slate-50">
            <ToastContainer position="top-right" autoClose={3000} theme="colored" />
            <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            <div className={`min-h-screen min-w-0 flex-1 transition-[margin] duration-300 ${sidebarOpen ? "lg:ml-64" : "lg:ml-20"}`}>
                <TopBar toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />

                <main className="px-4 pb-8 pt-24 sm:px-6 lg:px-8">
                    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                        <h2 className="text-xl font-semibold text-slate-900 sm:text-2xl">Landing Page Details</h2>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setOpenAddModal(true)}
                            sx={{ borderRadius: "50%", minWidth: "40px", minHeight: "40px" }}
                        >
                            <FiPlus size={20} />
                        </Button>
                    </div>

                    {error && <p className="text-red-500 mb-4">{error}</p>}

                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        loading={loading}
                        autoHeight
                    />

                    {/* ======================= ADD MODAL ======================= */}
                    <Dialog
                        open={openAddModal}
                        onClose={() => setOpenAddModal(false)}
                        fullWidth
                        maxWidth="md"
                    >
                        <DialogTitle>
                            <Typography variant="h6" align="center" fontWeight="bold">
                                Add Landing Page Details
                            </Typography>
                        </DialogTitle>

                        <div className="tabs-container">
                            {/* Tab Buttons */}
                            <div className="tabs-header">
                                <button
                                    className={`tab-btn ${activeTab === "overview" ? "active" : ""}`}
                                    onClick={() => setActiveTab("overview")}
                                >
                                    Tour Overview
                                </button>

                                <button
                                    className={`tab-btn ${activeTab === "itinerary" ? "active" : ""}`}
                                    onClick={() => setActiveTab("itinerary")}
                                >
                                    Itinerary
                                </button>
                            </div>

                            {/* Tab Content */}
                            <div className="tabs-content">
                                {activeTab === "overview" && (
                                    <div className="tab-panel">
                                        <DialogContent dividers sx={{ mt: 1 }}>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <select
                                                    name="category"
                                                    value={newTopThing.category}
                                                    onChange={handleCategoryChange}
                                                    className="w-full px-3 py-2 border rounded">
                                                    <option value="">Select Category</option>
                                                    {categoryList.map((cat, index) => (
                                                        <option key={index} value={cat}>
                                                            {cat}
                                                        </option>
                                                    ))}
                                                </select>

                                                <select
                                                    name="categoryTitle"
                                                    value={newTopThing.thing_id || ""}
                                                    onChange={(e) =>
                                                        setNewTopThing({
                                                            ...newTopThing,
                                                            thing_id: Number(e.target.value),
                                                        })
                                                    }
                                                    className="w-full px-3 py-2 border rounded"
                                                    disabled={!newTopThing.category} >

                                                    <option value="">Select Title</option>

                                                    {titleList
                                                        .filter(item => item.category === newTopThing.category && !usedThingIds.includes(item.id))
                                                        .map(item => (
                                                            <option key={item.id} value={item.id}>
                                                                {item.title}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>



                                            {/* ===================== TOUR OVERVIEW (TOP) ===================== */}
                                            <TourOverView
                                                tourOverview={tourOverview}
                                                setTourOverview={setTourOverview}
                                            />

                                            <Box mt={3} mb={3}>
                                                <hr />
                                            </Box>

                                            {/* ===================== TOUR GALLERY (TOP) ===================== */}

                                            <TourGallery
                                                gallery={gallery}
                                                setGallery={setGallery}
                                            />


                                            {/* ===================== PACKAGES (EXACT LIKE SCREENSHOT) ===================== */}
                                            <PackagesPage
                                                packages={packages}
                                                setPackages={setPackages}
                                            />

                                            <Box mt={3} mb={3}>
                                                <hr />
                                            </Box>

                                            {/* ===================== Highlights (EXACT LIKE SCREENSHOT) ===================== */}
                                            <TourHighlights value={highlights} setValue={setHighlights} />


                                            {/* ===================== Tips We SuggesT (EXACT LIKE SCREENSHOT) ===================== */}

                                            <TipsWeSuggest value={tipsWeSuggest} setValue={setTipsWeSuggest} />


                                            {/* ================= WHAT TO BRING (CHECKBOX UI) ================= */}
                                            <div className="space-y-3 mt-3">
                                                <h3 className="text-lg font-semibold">What to Bring</h3>
                                                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                                                    {bringItems.map((item, index) => (
                                                        <label
                                                            key={index}
                                                            className="flex items-center gap-2 p-2 border rounded-lg cursor-pointer hover:bg-gray-50"
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={item.selected || false}
                                                                onChange={(e) => {
                                                                    const updated = [...bringItems];
                                                                    updated[index] = {
                                                                        ...updated[index],
                                                                        selected: e.target.checked,
                                                                    };
                                                                    setBringItems(updated);
                                                                }}
                                                            />
                                                            <span>{item.label || item}</span>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>


                                            {/* ===================== Duration and Timings (EXACT LIKE SCREENSHOT) ===================== */}
                                            <DurationandTimings value={durationTimings} setValue={setDurationTimings} />


                                            {/* ===================== Pickup Information (EXACT LIKE SCREENSHOT) ===================== */}
                                            <PickUpInFormation value={pickupInfo} setValue={setPickupInfo} />

                                            {/* ===================== Instructions (EXACT LIKE SCREENSHOT) ===================== */}
                                            <TourInstructions value={tourInstructions} setValue={setTourInstructions} />


                                            {/* ===================== TTerms & Conditions (EXACT LIKE SCREENSHOT) ===================== */}
                                            <hr />
                                            <TermsConditions value={terms} setValue={setTerms} />


                                            {/* ===================== CANCELLATION POLICY ===================== */}
                                            <CancellationPolicy value={cancellationPolicy} setValue={setCancellationPolicy} />


                                        </DialogContent>
                                    </div>
                                )}

                                {activeTab === "itinerary" && (
                                    <div className="tab-panel">

                                        <Itinerary itinerary={itinerary} setItinerary={setItinerary} />


                                    </div>
                                )}
                            </div>
                        </div>







                        <DialogActions>
                            <Button onClick={() => setOpenAddModal(false)}>Cancel</Button>
                            <Button variant="contained" color="primary" onClick={handleSave}>
                                Save
                            </Button>
                        </DialogActions>
                    </Dialog>

                </main>
            </div>
        </div>
    );
}

export default LandingPage;
